import { Badge, ColorPaletteEnum, Tooltip } from '@wonderschool/common-base-ui';

export type BadgeWithTooltipProps = {
  label: string;
  color: ColorPaletteEnum;
  tooltip?: string;
};

/**
 * A standard badge with an optional tooltip.
 * @param label - The label of the badge.
 * @param color - The color of the badge.
 * @param tooltip - The tooltip of the badge, if provided.
 * @returns A badge with a tooltip.
 */
export function BadgeWithTooltip({ label, color, tooltip }: BadgeWithTooltipProps) {
  const badge = <Badge label={label} color={color} extraContainerClasses="whitespace-nowrap text-sm ring-2" />;

  if (!tooltip) {
    return badge;
  }

  return (
    <Tooltip action="hover" content={tooltip}>
      {badge}
    </Tooltip>
  );
}
